/** The market's name, as the lookbook's cover prints it under the imprint. */
const MARKET_NAME: Record<string, string> = {
    NZ: 'New Zealand',
    AU: 'Australia',
    US: 'United States',
};

/** Falls back to New Zealand, the market the cover was drawn for. */
export const lookbookMarketName = (country: string | undefined): string =>
    MARKET_NAME[country ?? ''] ?? 'New Zealand';

/** Where a project's lookbook is served. */
export const lookbookHref = (urlSegment: string): string =>
    `/project/${urlSegment}/lookbook.pdf`;
